export default "//static.tradera.net/touchweb/static/output/images/paynova.25f6689b.svg";